// @ts-check
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import { Checkbox, Input, Link } from '@material-ui/core';
import GitlabLogo from 'images/logos/gitlab-logo.svg';
import GithubLogo from 'images/logos/github-logo.svg';
import AsanaLogo from 'images/logos/asana-logo.svg';
import MondayLogo from 'images/logos/monday-logo.svg';
import ClickupLogo from 'images/logos/clickup-logo.svg';
import LinearLogo from 'images/logos/linear-logo.svg';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import _ from 'lodash';
import { LBButton } from '@linearb/buzz';

export const alternativePmToolsList = [
  { id: 1, name: 'Gitlab Issues', icon: GitlabLogo },
  { id: 2, name: 'Github Issues', icon: GithubLogo },
  { id: 3, name: 'Asana', icon: AsanaLogo },
  { id: 4, name: 'Monday', icon: MondayLogo },
  { id: 5, name: 'Clickup', icon: ClickupLogo },
  { id: 6, name: 'Linear', icon: LinearLogo }
];

const PmToolIconWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  position: static;
  width: 2rem;
  height: 2rem;

  border: 1px solid #ebeef5;
  box-sizing: border-box;
  border-radius: 4px;

  margin-right: 1rem;
  & > img {
    width: 1.2rem;
    height: 1.2rem;
  }
`;

const ToolItem = ({ tool, isChecked, onChange }) => {
  const { name, icon } = tool;
  return (
    <Flex mb='x-small' items='center'>
      <Checkbox
        onChange={onChange}
        checked={isChecked}
        inputProps={{
          'aria-label': 'primary checkbox'
        }}
        color='primary'
      />
      <PmToolIconWrapper>
        <img src={icon} />
      </PmToolIconWrapper>
      <Text>{name}</Text>
    </Flex>
  );
};

const FavouritePmToolsModal = ({ closeModal }) => {
  const [checkedTools, setCheckedTools] = useState(
    _.fill(Array(alternativePmToolsList.length), false)
  );
  const [customToolValue, setCustomValue] = useState('');

  const tutorialLink =
    'https://linearb.helpdocs.io/article/p0a1a6m12x-connect-linear-b-to-your-project-management-tool';

  const onCheckTool = idx => {
    const updatedCheckedTools = checkedTools.map((value, index) =>
      index === idx ? !value : value
    );
    setCheckedTools(updatedCheckedTools);
  };

  const onSubmit = () => {
    const selectedTools = alternativePmToolsList
      .filter((_tool, idx) => checkedTools[idx])
      .map(tool => tool.name);

    if (customToolValue) {
      selectedTools.push(customToolValue);
    }
    selectedTools.forEach(toolName => {
      TrackingService.logEvent(
        TRACKING.EVENTS.CLICK,
        TRACKING.SUB_EVENTS.DISMISS_CONNECT_PM_TOOL.SELECT_ALTERNATIVE_PM_TOOL(
          toolName
        )
      );
    });

    closeModal();
  };

  useEffect(() => {
    TrackingService.logEvent(
      TRACKING.EVENTS.CLICK,
      TRACKING.SUB_EVENTS.DISMISS_CONNECT_PM_TOOL.CLICKED()
    );
  }, []);

  return (
    <Flex direction='column' padding='medium'>
      <Text size='x-large' pb={SPACES['small']}>
        Help us get better
      </Text>
      <Text size='medium' pb={SPACES['big']}>
        Which tool you do use to manage your projects?
      </Text>
      <Flex direction='column' pb='small'>
        {alternativePmToolsList.map((tool, idx) => (
          <ToolItem
            key={tool.id}
            tool={tool}
            isChecked={checkedTools[idx]}
            onChange={() => onCheckTool(idx)}
          />
        ))}
      </Flex>
      <Flex pb='medium' direction='column'>
        <Input
          type='text'
          placeholder='Specify other tools...'
          value={customToolValue}
          onChange={({ target }) => setCustomValue(target.value)}
        />
      </Flex>
      <Link href={tutorialLink} target='_blank'>
        Why should I connect my project tool to LinearB?
      </Link>

      <Flex justify='flex-end' pt='medium'>
        <Padding r='small'>
          <LBButton role='submit' size='lg' onClick={onSubmit}>
            Done
          </LBButton>
        </Padding>
      </Flex>
    </Flex>
  );
};

export default FavouritePmToolsModal;
